import React from "react";
import { getStyle } from "../../styles/styles";
import { Breadcrumb } from "antd";
import { confirmPickAndPack, confirmReceivedOrder, sendEmailYourOrder, getDeliveryInformation, getOrdersForPickAndPack } from "../../networking/NetworkingBankNotes";
import AlertBox from "../shared/AlertBox";
import NewDynamicTable from "../shared/NewDynamicTable";
import { getDefaultPagingNumberOfItems } from "../../helpers/PackageJsonHelper";
import { PrintLabel,Print, PrintConfirmation } from "../tools/print/PrintLabel"
import { getLookUpTable } from '../../networking/Networking';
import DynamicSelect from '../shared/DynamicSelect';
import { removeWhiteSpace } from '../../helpers/FormatHelper';
import LoadingBox from "../shared/LoadingBox";

var style = getStyle();

export default class OrderDeliveryScreen extends React.Component {
    state = {
        bnOrderNo: 0,
        orderReference: '',
        reload: false,
        totalPages: 0,
        //delivery information
        customerName: '',
        deliveryDate: '',
        deliveryMethod: '',
        totalOrder: '',
        contactName: '',
        deliveryAddress: '',
        //lists
        listSameDeliveryOrders: [],
        listSelectedOrders: [],
        //alert
        showAlert: false,
        showYesNoAlert: false,
        showYesNoPrintAlert: false,
        alertTitle: '',
        alertMessage: '',
        yesNoAlertMessage: '',
        yesNoPrintAlertMessage: '',
        list_deliverycompany: [],
        deliverycompany: '',
        updateToken:'',
        loading: false,

        readyForButtonLabel: 'Ready for Shippment'
    }

    componentDidMount(){
        if(this.props.type == 'Delivery') { this.setState({readyForButtonLabel: "Shipped"}) }
        if(this.props.data > 0) {

            getDeliveryInformation(this.props.data).then(
                (value) =>{
                    if(value){
                        const selectedOrder = []
                        selectedOrder.push({BNOrderNo:this.props.data, UpdateToken:value.UpdateToken})
                        this.setState({bnOrderNo: this.props.data,listSelectedOrders: selectedOrder,
                            customerName: value.CustomerName, deliveryDate: value.DeliveryDate,
                            deliveryMethod: value.DeliveryMethod, totalOrder: value.TotalOrder,
                            contactName: value.DeliveryContactName, deliveryAddress: value.DeliveryAddress,
                            deliverycompany:value.ShippingCompany, orderReference: value.ReferenceNo, updateToken:value.UpdateToken
                        });
                    }
                }
            )

            //var selectedOrder = []
            //selectedOrder.push(this.props.data)
            //this.setState({bnOrderNo: this.props.data, listSelectedOrders: selectedOrder})
            let outTransit = false;
            if(this.props.outTransit !== undefined && this.props.outTransit !== null) { outTransit = this.props.outTransit; }
            getOrdersForPickAndPack(this.props.data, outTransit, 0, 100).then(
                (value) => {
                    var totalCount = value.totalCount;
                    var pages = Math.ceil(totalCount/getDefaultPagingNumberOfItems());
                    if(totalCount === 0){
                        this.setState({listSameDeliveryOrders: [], totalPages: pages});
                    }else{
                        this.setState({listSameDeliveryOrders: value.result, totalPages: pages,});
                    }
                }
            )

            
        }
        getLookUpTable("BN Delivery Companies").then(
            (json) => {
                if (json !== undefined) {
                    var table = json.lookUpTables[0].lookUpTableDetails;
                    for (var i = 0; i < table.length; i++) {
                        table[i].value = table[i].LookUpTableDetail;
                        table[i].name = table[i].LookUpTableDetail;
                    }
                    this.setState({ list_deliverycompany: table });
                }
        });
    }
    
    handleBackLink() {
        this.props.backLink();
    }

    handleUpdateOrderReference = (event) => {
        this.setState({ orderReference: event.target.value });
    }

    handleSaveClick = async (event) => {
        if (event != null) {
            event.preventDefault();
        }
        if(this.state.deliverycompany!=='' && this.state.deliverycompany!==null && this.state.orderReference!=='' && this.state.orderReference!==null){
            if(!this.props.outTransit) {
                this.setState({ showYesNoAlert: true, yesNoAlertMessage: 'Are you sure you want to change the status to Ready for Delivery?'});
            } else {
                this.setState({ showYesNoAlert: true, yesNoAlertMessage: 'Are you sure to ship this order?'});// 'Are you sure you want to change the status to Out transit?'});
            }
        }        
    }

    updateOrderDelivery = async () => {
        this.setState({ loading: true }, async () => {
            if (this.state.orderReference !== '') {
                const response = await confirmPickAndPack(this.state.listSelectedOrders, 'Ready for delivery', this.state.orderReference, this.state.deliverycompany);
                if (response.success) {
                    this.setState({ showAlert: true, alertTitle: 'Success', alertMessage: 'Delivery status updated successfully.', reload: true, loading: false,
                        showYesNoPrintAlert: true, yesNoPrintAlertMessage: 'Do you want to print the label for this order?'
                     });
                    //Print(this.props.data, this.state.listSelectedOrders);
                } else {
                    this.setState({
                        showAlert: true, alertTitle: 'Error',
                        alertMessage: response !== undefined ? response.Message : 'Something went wrong. Please try again later.', loading: false
                    });
                }
            } else {
                this.setState({ showAlert: true, alertTitle: 'Warning', alertMessage: 'Reference number cannot be empty. Please try again.', loading: false });
            }
        });
    }

    updateOrderDeliveryTime = async () => {
        this.setState({ loading: true }, async () => {
            const response = await confirmReceivedOrder(this.props.data, this.state.updateToken);
            if (response.success) {
                await sendEmailYourOrder(this.props.data, this.state.updateToken);
                this.setState({ showAlert: true, alertTitle: 'Success', alertMessage: 'Delivery status updated successfully.', reload: true, loading: false });
            } else {
                this.setState({
                    showAlert: true, alertTitle: 'Error',
                    alertMessage: response !== undefined ? response.Message : 'Something went wrong. Please try again later.', loading: false
                });
            }
        });
    }

    closeAlert = () => {
        this.setState({ showAlert: false, alertTitle: '', alertMessage: '' }, () => {
            if(this.state.reload) { this.props.backLink(); }
        });
    }
    
    noConfirmAlert = () => {
        this.setState({ showYesNoAlert: false, yesNoAlertMessage: '' });
    }

    yesConfirmAlert = () => {
        this.setState({ showYesNoAlert: false });

        if(this.props.outTransit) {
            this.updateOrderDeliveryTime();
        } else {
            this.updateOrderDelivery();
        }
    }

    noConfirmPrintAlert = () => {
        this.setState({ showYesNoPrintAlert: false, yesNoPrintAlertMessage: '' });
    }

    yesConfirmPrintAlert = () => {
        this.setState({ showYesNoPrintAlert: false, yesNoPrintAlertMessage: '' });
        Print(this.props.data, this.state.listSelectedOrders);
    }

    handleSelectClick = (rowKeys) => {
        const list = [];
        list.push({BNOrderNo:this.props.data, UpdateToken:this.state.updateToken});
        for(let i=0;i<rowKeys.length;i++ )
        {
            if(rowKeys[i] !== this.props.data)
            {
                const item = this.state.listSameDeliveryOrders.find(d => d.Key === rowKeys[i]);
                if(item)
                {list.push({BNOrderNo:rowKeys[i], UpdateToken:item.UpdateToken});}
            }
        }

        this.setState({ listSelectedOrders: list })
    }
    
    handleSelectDeliveryCompany = (value) => {
        if (value.value !== null && value.value !== undefined && value.value !== '') {
            this.setState({ deliverycompany: value.value })
        }else{            
            this.setState({ deliverycompany: '' })
        }
    }

    render() {        
        var bnOrderTitle = (
            <h3 className="uk-heading-divider" style={style.titleStyle} >
                <button className="uk-button uk-button-text uk-margin-small-right min-width-0" onClick={this.handleBackLink.bind(this)}>
                    <i className="fa fa-arrow-left back-arrow-white"></i>
                </button>
                Orders Ready for Delivery
            </h3>);
        if (this.props.mainTitle != null) {
            bnOrderTitle = '';
        }

        var headerTitle = 'Orders Ready for Delivery';
        if (this.props.outTransit) { headerTitle = 'Orders Out Transit'; }

        var classNameInputName = "uk-input";
        var classNameSelect = "uk-select";
        if (this.state.orderReference === '' || this.state.orderReference === null) {
            classNameInputName = "uk-input uk-form-danger";
        }
        if (this.state.deliverycompany === '' || this.state.deliverycompany === null) {
            classNameSelect = "uk-select uk-form-danger";
        }

        return(
            <div>
                <LoadingBox loading={this.state.loading} />
                <div className="breadcrumb-div">
                    <Breadcrumb separator=">">
                        <Breadcrumb.Item className="breadcrumb-item" onClick={this.handleBackLink.bind(this)}>{this.props.mainTitle}</Breadcrumb.Item>
                        <Breadcrumb.Item className="breadcrumb-item-bold">{headerTitle} - BNOrderNo: {this.state.bnOrderNo}</Breadcrumb.Item>
                    </Breadcrumb>
                </div>
                <div>
                    {bnOrderTitle}
                    <div>
                        <ul className="uk-tab">
                            <li className={'uk-active'}><a>Order Information</a></li>
                        </ul>
                    </div>
                    <div>
                        <form className="uk-grid">
                            <div className="uk-width-1-1">
                                <div className="uk-grid uk-margin">
                                    <div className="uk-width-1-3">
                                        <label className="uk-form-label uk-align-left" style={{width: '120px'}}>Customer Name:</label>
                                        <label className="uk-form-label uk-align-left">{this.state.customerName}</label>
                                    </div>
                                    <div className="uk-width-1-2">
                                        <label className="uk-form-label uk-align-left" style={{width: '120px'}}>Delivery Date:</label>
                                        <label className="uk-form-label uk-align-left">{this.state.deliveryDate}</label>
                                    </div>
                                </div>
                            </div>
                            <div className="uk-width-1-1">
                                <div className="uk-grid uk-margin">
                                    <div className="uk-width-1-3 ">
                                        <label className="uk-form-label uk-align-left" style={{width: '120px'}}>Delivery Method:</label>
                                        <label className="uk-form-label uk-align-left">{this.state.deliveryMethod}</label>
                                    </div>
                                    <div className="uk-width-1-2">
                                        <label className="uk-form-label uk-align-left" style={{width: '120px'}}>Total Order:</label>
                                        <label className="uk-form-label uk-align-left">{this.state.totalOrder}</label>
                                    </div>
                                </div>
                            </div>
                            <div className="uk-width-1-1">
                                <div className="uk-grid uk-margin">
                                    <div className="uk-width-1-3">
                                        <label className="uk-form-label uk-align-left" style={{width: '120px'}}>Contact Name:</label>
                                        <label className="uk-form-label uk-align-left">{this.state.contactName}</label>
                                    </div>
                                    <div className="uk-width-1-2">
                                        <label className="uk-form-label uk-align-left" style={{width: '120px'}}>Delivery Address:</label>
                                        <label className="uk-form-label uk-align-left">{this.state.deliveryAddress}</label>
                                    </div>
                                </div>
                            </div>
                            <div className="uk-width-1-1">
                                <div className="uk-grid uk-margin">
                                    <div className="uk-width-1-3">
                                        <label className="uk-form-label uk-align-left" style={{width: '120px'}}>Delivery Companies:</label>
                                        <div className="uk-align-left" style={{marginRight: '0px'}}>
                                            <DynamicSelect
                                                className={classNameSelect}
                                                style={{ width: '100px'}}
                                                objValue={{value: this.state.deliverycompany, name: this.state.deliverycompany}} 
                                                getValue={this.handleSelectDeliveryCompany} 
                                                listHasPlaceholder={true} 
                                                data={this.state.list_deliverycompany} 
                                                id="form-orderInfo-deliveryCompanies" />
                                        </div>
                                        
                                    </div>
                                    {!this.props.outTransit && <div className="uk-width-1-2">
                                        <label className="uk-form-label uk-align-left" style={{width: '120px'}}>Reference Number:</label>
                                        <div className="uk-align-left" style={{ ...getStyle().inputStyle, marginTop: '5px' }}>
                                            <input
                                                className={classNameInputName}
                                                id="delivery-reference-no"
                                                type="text"
                                                placeholder="Enter a reference number"
                                                value={this.state.orderReference}
                                                onChange={this.handleUpdateOrderReference}
                                                autoFocus={true}/>
                                        </div>
                                    </div>}
                                </div>
                            </div>
                        </form>
                        <div className="uk-width-1-2">
                            <div className="uk-margin" style={getStyle().inputStyle}>
                                <button className="uk-button uk-button-green" onClick={this.handleSaveClick}>{this.state.readyForButtonLabel}</button>
                            </div>
                        </div>
                    </div>
                    <div>
                        <h3 className="uk-heading-divider" style={style.titleStyle}>Orders with same Delivery Address</h3>
                        <form className="uk-grid">
                            {this.state.listSameDeliveryOrders.length > 0 &&<NewDynamicTable id="order-delivery-screen-table" 
                                data={this.state.listSameDeliveryOrders}
                                hiddenHeaders={['Key','UpdateToken']}
                                enableClick={false}
                                useSelection={!this.props.outTransit}
                                selectionID={"Order ID"}
                                onChangeSelection={this.handleSelectClick} 
                                selectedRows={this.state.listSelectedOrders}
                            />}
                            <h5 style={style.alignCenter} hidden={this.state.listSameDeliveryOrders.length > 0}>No records found.</h5>
                        </form>
                    </div>
                </div>
                    <AlertBox id="order-delivery-alert"
                        type="Ok"
                        open={this.state.showAlert}
                        title={this.state.alertTitle}
                        message={this.state.alertMessage}
                        okClick={this.closeAlert}
                        onClose={this.closeAlert}/>

                    <AlertBox id="confirm-update-order-alert"
                        type     = "Yes/No"
                        open     = {this.state.showYesNoAlert}
                        title    = "Please confirm"
                        message  = {this.state.yesNoAlertMessage}
                        yesClick = {this.yesConfirmAlert}
                        noClick  = {this.noConfirmAlert}
                    />
                    
                    <AlertBox id="confirm-print-label-alert"
                        type     = "Yes/No"
                        open     = {this.state.showYesNoPrintAlert}
                        title    = "Please confirm"
                        message  = {this.state.yesNoPrintAlertMessage}
                        yesClick = {this.yesConfirmPrintAlert}
                        noClick  = {this.noConfirmPrintAlert}
                    />
            </div>
        )
    }
}